import { render, staticRenderFns } from "./admin-import-coins.vue?vue&type=template&id=25b7f39e&scoped=true&"
import script from "./admin-import-coins.vue?vue&type=script&lang=js&"
export * from "./admin-import-coins.vue?vue&type=script&lang=js&"
import style0 from "./admin-import-coins.vue?vue&type=style&index=0&id=25b7f39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7f39e",
  null
  
)

export default component.exports